import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface CoursePreference {
	id: string;
	title: string;
}

export interface CoursePreferencesState {
	courses: CoursePreference[];
	isLoading: boolean;
	isError: boolean;
	error: string | null;
	page: number;
	hasNextPage: boolean;
	isFetching: boolean;
}

const initialState: CoursePreferencesState = {
	courses: [],
	isLoading: false,
	isError: false,
	error: null,
	page: 1,
	hasNextPage: false,
	isFetching: false,
};

const coursePreferencesSlice = createSlice({
	name: "coursePreferences",
	initialState,
	reducers: {
		setCoursesLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setCoursesError: (state, action: PayloadAction<string>) => {
			state.isError = true;
			state.error = action.payload;
			state.isLoading = false;
		},
		clearCoursesError: (state) => {
			state.isError = false;
			state.error = null;
		},
		setCourses: (state, action: PayloadAction<{ courses: CoursePreference[]; page: number; hasNextPage: boolean }>) => {
			state.courses = action.payload.courses;
			state.page = action.payload.page;
			state.hasNextPage = action.payload.hasNextPage;
			state.isLoading = false;
			state.isError = false;
			state.error = null;
		},
		addMoreCourses: (state, action: PayloadAction<{ courses: CoursePreference[]; page: number; hasNextPage: boolean }>) => {
			state.courses = [...state.courses, ...action.payload.courses];
			state.page = action.payload.page;
			state.hasNextPage = action.payload.hasNextPage;
			state.isFetching = false;
		},
		setFetching: (state, action: PayloadAction<boolean>) => {
			state.isFetching = action.payload;
		},
		resetCourses: (state) => {
			state.courses = [];
			state.page = 1;
			state.hasNextPage = false;
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.isFetching = false;
		},
	},
});

export const {
	setCoursesLoading,
	setCoursesError,
	clearCoursesError,
	setCourses,
	addMoreCourses,
	setFetching,
	resetCourses,
} = coursePreferencesSlice.actions;

export default coursePreferencesSlice.reducer;
